<template>
  <div style="text-align: center" @mouseover="mouseEnter" @mouseout="mouseOut"
    :class="{ 'combination-isHide': option.attribute.isCombinationPageShow, 'combination-isShow': option.attribute.isCombinationPageShow && showCurrent }">
    <t-pagination-mini :class="['combination-page', flagType]" :size="option.attribute.size"
      :layout="option.attribute.layout" @change="jumpChange" />
  </div>
</template>

<script>
import option from '../echarts/attrs/cpt-chart-candlestick-line-option';
import { CombinationPage } from '@/views/viewsFunction/designerMethods'
import { mapActions, mapState } from 'pinia'
import { useCombinationPageStore } from '@/stores/combinationPageStore'
export default {
  name: "cpt-combination-page",
  props: {
    option: Object, current: Object, components: Array,
    cacheComponents: Array,

  },
  data() {
    return {
      flagType: ''
    }
  },
  created() {
    this.autoJump(this.option.attribute)
    this.setPageData(this.current.id, 0, false)
  },
  mounted() {
    this.getTabActiveKey()
    // CombinationPage.setCombinationPageShow(this.current)
  },
  computed: {
    ...mapState(useCombinationPageStore, {
      showCurrent(store) {
        return store.pageData[this.current.id].includes(true)
      }
    })
  },
  methods: {
    ...mapActions(useCombinationPageStore, ['setPageData']),
    getTabActiveKey() {
      let tabEvent = this.current.cptOption.interaction.eventList.find(item => item.intType === 'combinationTabPage')
      // let comps = this.components || this.cacheComponents
      if (!tabEvent) {
        return
      }

      window.addEventListener('message', message => {
        console.log(message, 'messagemessagemessage');
        let msg = message?.data?.data || '{}'
        console.log(msg, 'msgmsgmsgmsgmsgmsg');
        if (message.data.type === 'TABCHANGEMESSAGE') {
          let data = JSON.parse(msg)
          // this.flagType = message.data.activeKey == 0 ? 'min' : 'max'
          console.log(data, 'qwdiojqwijdwqidijodqwiojdqwiojd');
          let max = data.tabIndex == data.options.length - 1 ? 'max' : ''
          this.flagType = 'combination-page-' + (data.tabIndex == 0 ? 'min' : max)
        }
        console.log(this.flagType, 'qwodkoqwkdoqwkoqdwkodqokpko');
      })
      // let tab = comps.find(item => item.id == tabEvent.tabId)
      // if (!tab) {
      //   return
      // }
      // let tabOption = JSON.parse(tab.cptOption.cptDataForm.dataText)

      // let max = tab.tabIndex == (tabOption.options.length - 1) ? 'max' : ''
      // this.flagType = tab.tabIndex == 0 ? 'min' : max
      // console.log(tab,tab.tabIndex, this.flagType, 'tagbosjsfkjasdkoaskodasodas');

    },
    autoJump(attr) {
      const that = this;
      if (attr.autoSwitch) {
        setTimeout(() => {
          that.jumpChange({ trigger: attr.trigger })
        }, attr.timeout * 1000)
      }
    },
    jumpChange(context) {
      console.log(context, 'context')
      this.$emit("clickHandler", this.option.interaction, context.trigger, context.trigger, 'cpt-combination-page', context.trigger, this.current)

    },
    mouseEnter() {
      this.setPageData(this.current.id, 0, true)
    },
    mouseOut() {
      this.setPageData(this.current.id, 0, false)
    }
  }
}
</script>

<style>
.combination-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.combination-page .t-button {
  width: 100%;
  height: 100%
}

.combination-page .t-button svg {
  width: 100%;
  height: 100%;
}

.combination-page-min .t-pagination-mini__prev,
.combination-page-max .t-pagination-mini__next {
  filter: brightness(0.5);
  cursor: not-allowed;
}

.combination-page-min .t-pagination-mini__prev:active,
.combination-page-max .t-pagination-mini__next:active,
.combination-page-min .t-pagination-mini__prev:hover,
.combination-page-max .t-pagination-mini__next:hover {
  background-color: transparent !important;
}

/*   */
.combination-isHide .combination-page {
  transform: translateY(100%);
  transition: .3s ease-in-out;
  transition-delay: 300ms;
}

.combination-isShow .combination-page {
  transform: translateY(0);
}
</style>